import React from 'react';
import {Card} from 'antd';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import StationTable from '../components/StationTable';
import StationTableMobile from '../components/StationTableMobile';
import {fetchStations, updateStation, setStationState, deleteStation} from '../actions/station'

class Stations extends React.Component {
  componentWillMount() {
    this.props.dispatch(fetchStations(0, -1))
  }

  handleUpdate = (station) => {
    this.props.dispatch(updateStation(station))
  }

  handleDelete = (station) => {
    this.props.dispatch(deleteStation(station))
  }

  handleStationButtonCamera = (station) => {
    this.props.dispatch(setStationState(station))
  }

  render() {
    const {
      fetching,
      stations,
      groups,
      treeGroups,
      isMobile,
      currentUser
    } = this.props
    const role = currentUser
      ? currentUser.role
      : 256
    return (<div>
      <Card title="Quản lý trạm" bordered={false} className="card">{
          isMobile
            ? <StationTableMobile role={role} stations={stations} groups={groups} treeGroups={treeGroups} fetching={fetching} onUpdate={this.handleUpdate} onDelete={this.handleDelete} onStationButtonCamera={this.handleStationButtonCamera}/>
            : <StationTable role={role} stations={stations} groups={groups} treeGroups={treeGroups} fetching={fetching} onUpdate={this.handleUpdate} onDelete={this.handleDelete} onStationButtonCamera={this.handleStationButtonCamera}/>
        }
      </Card>
    </div>);
  }
}

Stations.propTypes = {
  dispatch: PropTypes.func,
  currentSystem: PropTypes.object,
  currentUser: PropTypes.object,
  currentStation: PropTypes.object,
  stations: PropTypes.array,
  groups: PropTypes.array,
  treeGroups: PropTypes.array,
  fetching: PropTypes.bool,
  error: PropTypes.string
}

const mapStateToProps = function(state) {
  return {
    currentSystem: state.system.currentSystem,
    currentUser: state.user.currentUser,
    currentStation: state.station.currentStation,
    stations: state.station.stations,
    groups: state.group.groups,
    treeGroups: state.group.treeGroups,
    fetching: state.station.fetching,
    error: state.station.error
  }
}

export default connect(mapStateToProps)(Stations)



// WEBPACK FOOTER //
// ./src/pages/Stations.js